import useApiRequest from 'api/useApiRequest';
import {
  fetchTranscriptsEvents,
  fetchTranscriptsDebates,
  createDiarisedTranscript,
  fetchListTranscripts,
  fetchDownloadTranscript,
  deleteTranscript,
  updateDiarisedTranscript,
} from 'api/services/transcriptsService';

const useTranscripts = () => {
  const { request } = useApiRequest();

  const getTranscriptsEvents = async ({ isoDate, signal }) => {
    const { data } = await fetchTranscriptsEvents(request, { isoDate, signal });
    return data;
  };

  const getTranscriptsDebates = async ({ isoDate, signal }) => {
    const { data } = await fetchTranscriptsDebates(request, { isoDate, signal });
    return data;
  };

  const createTranscript = async (params) => {
    const { data, status } = await createDiarisedTranscript(request, params);
    return { data, status };
  };

  const updateTranscript = async (params) => {
    const { data, status } = await updateDiarisedTranscript(request, params);
    return { data, status };
  };

  const getListTranscripts = async (params) => {
    const { data } = await fetchListTranscripts(request, params);
    return data;
  };

  const downloadTranscript = async (params) => {
    const { data, headers } = await fetchDownloadTranscript(request, params);
    return { blob: data, filename: headers?.['content-disposition']?.match(/filename="?([^"]+)"?/i)?.[1] };
  };

  const removeTranscript = async ({ id, signal }) => {
    const { status } = await deleteTranscript(request, { id, signal });
    return { status };
  };

  return {
    getTranscriptsEvents,
    getTranscriptsDebates,
    createTranscript,
    getListTranscripts,
    downloadTranscript,
    updateTranscript,
    removeTranscript,
  };
};

export default useTranscripts;
